import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'router-fragment-outlet',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterComponent implements OnInit {
  @Input() basePath: string;
  @Input() baseFragment: string;
  @Input() navigateBase = true;

  active: string;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) {}

  ngOnInit(): void {
    this.route.fragment.pipe(untilDestroyed(this)).subscribe((fragment) => {
      if (this.navigateBase) {
        if (!fragment) {
          if (this.baseFragment) {
            this.router.navigate([this.basePath], {
              fragment: this.baseFragment,
              replaceUrl: true,
              queryParamsHandling: 'preserve',
            });
          }
          this.active = '';
        } else {
          this.active = fragment;
        }
      }
    });
  }
}
